export function formatUserName(firstName: string | null = '', lastName: string | null = ''): string {
  return `${firstName || ''} ${lastName || ''}`.trim();
}

export default formatUserName;